import { Theme, useMediaQuery } from "@mui/material";

export const useIsMobile = (): boolean => {
  const isMobileWidth = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );
  const isMobileHeight = useMediaQuery("(max-height: 600px)");
  return isMobileWidth || isMobileHeight;
};
